import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import './index.css';
import App from './App';
import DataContext from './component/loginContext';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <DataContext>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </DataContext>
);

reportWebVitals();